import React, { useRef, useState } from "react";
import { BarChartHeader } from "./BarChartHeader";
import { BarChartActions } from "./BarChartActions";
import { BarChartCanvas } from "./BarChartCanvas";
import { BarChartModal } from "./BarChartModal";
import { useBarChartExport } from "./hooks/useBarChartExport";
import type { BarChartData } from "@/lib/chat/parseBarChartBlock";

interface BarChartProps {
  data: BarChartData;
}

export const BarChart: React.FC<BarChartProps> = ({ data }) => {
  const exportRef = useRef<HTMLDivElement>(null);
  const [expanded, setExpanded] = useState(false);
  const { exportPNG } = useBarChartExport(exportRef, data.title);

  return (
    <>
      <div className="relative w-full overflow-hidden rounded-xl border border-border/60 bg-card shadow-sm">
        <div ref={exportRef}>
          <BarChartHeader title={data.title} />
          <BarChartCanvas data={data} />
        </div>
        <BarChartActions
          onDownload={exportPNG}
          onExpand={() => setExpanded(true)}
        />
      </div>

      <BarChartModal
        open={expanded}
        onClose={() => setExpanded(false)}
        data={data}
      />
    </>
  );
};
